import { TexturesNames } from '../types'

/**
 * Specialny konfig pre sponzorov v hre
 */
export const sponsorsConfig = {

  // bannery
  banners: [

    {
      name: 'vshosting',
      textureName: TexturesNames.colorGradientVshosting,
      textureNameScreens: TexturesNames.screensVshosting,
      active: true,
      times: [

        {
          from: 1723672800000, // 15.8.2024
          to: 1724882400000, // 29.8.2024
          percent: 0.1 // 10%
        },
        {
          from: 1724882400000, // 29.8.2024
          to: 1726092000000, // 12.9.2024
          percent: 0.3 // 30%
        },

      ]
    }

  ]

}
